export const FETCH_MASTER_CONFIG = "FETCH_MASTER_CONFIG";
export const FETCH_MASTER_CONFIG_PENDING = "FETCH_MASTER_CONFIG_PENDING";
export const FETCH_MASTER_CONFIG_REJECTED = "FETCH_MASTER_CONFIG_REJECTED";
export const FETCH_MASTER_CONFIG_FULFILLED = "FETCH_MASTER_CONFIG_FULFILLED";

// Fetches the DEFAULT master config only to source Prizes/Tnc for
// underage users — the reducer merges just those two keys into the existing
// country-specific state.data, leaving everything else untouched.
export const FETCH_DEFAULT_MASTER_CONFIG_GATED_CONTENT =
  "FETCH_DEFAULT_MASTER_CONFIG_GATED_CONTENT";
export const FETCH_DEFAULT_MASTER_CONFIG_GATED_CONTENT_PENDING =
  "FETCH_DEFAULT_MASTER_CONFIG_GATED_CONTENT_PENDING";
export const FETCH_DEFAULT_MASTER_CONFIG_GATED_CONTENT_REJECTED =
  "FETCH_DEFAULT_MASTER_CONFIG_GATED_CONTENT_REJECTED";
export const FETCH_DEFAULT_MASTER_CONFIG_GATED_CONTENT_FULFILLED =
  "FETCH_DEFAULT_MASTER_CONFIG_GATED_CONTENT_FULFILLED";
